import React from 'react'
import { connect } from 'react-redux'
import settings from 'settings'

// components
import Icon from 'app/views/components/Icon'

import {
  removeCodeTab,
  changeCodeTab,
  changeCode,
} from 'app/state/modules/codeReview'
import CodeReviewEditor from 'app/views/components/CodeReviewEditor'

import Loader from '../Loader'
import Dot from './Dot'

class CodeReview extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
    this.codeReviewRef = null
  }

  componentDidMount() {
    localStorage.removeItem('codingEditorSessions')
  }

  renderTabName(tab) {
    const { file } = tab
    const parts = (file || '').split('/')
    if (parts.length > 0) {
      return parts[parts.length - 1]
    }
    return ' - '
  }

  renderEditor() {
    if (this.props.tabs.length > 0 && this.props.indexEditing >= 0) {
      const tab = this.props.tabs[this.props.indexEditing]
      if (tab && tab.loading) {
        return (
          <div
            className="uk-flex uk-flex-center uk-flex-middle uk-flex-column"
          >
            <br />
            <br />
            <Loader
              visible
              ratio={0.8}
              textClassName="uk-text-small uk-text-secondary"
              text="Loading Code..."
            />
          </div>
        )
      }
      if (tab) {
        return (
          <CodeReviewEditor
            contentUUID={this.props.contentUUID}
            fileName={tab.file}
            sessions={this.state.sessions}
            onRef={(ref) => { this.codeReviewRef = ref }}
            markers={this.props.highlightedFiles[this.props.tabs[this.props.indexEditing].file] ? this.props.markers.filter((i) => i.fileName === this.props.tabs[this.props.indexEditing].file) : []}
            readOnly={this.props.lockedFiles[this.props.tabs[this.props.indexEditing].file]}
            isLight
            onFullScreen={this.props.onFullScreen}
            isFullScreen={this.props.isFullScreen}
            onUpdate={(code) => {
              this.props.changeCode(this.props.indexEditing, code)
            }}
            itemKey={this.props.indexEditing}
            engine={settings.languages[this.props.engine]}
            code={tab.code}
            displayBar
            displaySubmitButton
            ecsTaskDefinition=""
            editorId="editor-sidebar"
            hasTest={false}
            onSubmitClick={() => { }}
            onPatch={() => { }}
            onSetEngine={() => { }}
            onReplSetEngine={() => { }}
            socket={null}
            visible
          />
        )
      }
    }
    return null
  }

  render() {
    const noTabs = this.props.tabs.length === 0 && !this.props.isFullScreen
    if (this.props.loadingVersion) {
      return (
        <div
          className="uk-flex uk-flex-1 uk-flex-center uk-flex-middle"
        >
          <Loader visible ratio={0.7} text="Loading version..." />
        </div>
      )
    }
    if (noTabs) {
      return (
        <div className="uk-padding uk-text-center uk-text-small">
          Click on a file in the filetree to the left to edit it.
        </div>
      )
    }
    return (
      <div>
        <ul
          className={`uk-tab${this.props.isFullScreen ? ' uk-flex uk-flex-row uk-flex-nowrap' : ' uk-flex uk-flex-row uk-flex-nowrap'}`}
          id="tab-code-review-editor"
          style={{
            marginBottom: 0,
            maxWidth: this.props.isFullScreen ? '84vw' : null,
            overflowX: 'auto',
            overflowStyle: 'none',
          }}
        >
          {this.props.tabs.map((tab, index) => {
            return (
              <li
                key={`tab-${index}`}
                className={(this.props.indexEditing === index) ? ('uk-active') : ('')}
                onClick={() => {
                  this.props.changeCodeTab(tab.file)
                  if (this.props.highlightedFiles[tab.file]) {
                    const markersFile = this.props.markers.filter((i) => i.fileName === tab.file)
                    const { startRow } = markersFile[markersFile.length - 1]
                    const top = (startRow * 19 < 150 ? 150 : startRow * 19) - 150
                    setTimeout(() => {
                      window.codeReviewEditAreaScroll(top)
                    }, 0)
                  }
                }}
                data-uk-tooltip={`title: ${tab.file};pos: top`}
              >
                <a
                  className={`uk-inline${this.props.lockedFiles[tab.file] ? ' uk-padding-remove-left' : ''}`}
                  href="#"
                  style={{ textTransform: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                  {(tab.changed) && (
                    <Dot />
                  )}
                  {(this.props.lockedFiles[tab.file]) ? (
                    <Icon
                      className="uk-text-secondary uk-margin-small-left uk-margin-small-right"
                      name="lock"
                      ratio={0.8}
                    />
                  )
                    : null}
                  <span
                    style={{
                      ...(this.props.highlightedFiles[tab.file] ? {
                        backgroundColor: 'green',
                        color: '#fff',
                        padding: '0px 6px',
                        borderRadius: 5,
                      } : {}),
                    }}
                  >
                    {this.renderTabName(tab)}
                  </span>
                  {!tab.loading ? (
                    <Icon
                      className="uk-position-center-right"
                      onClick={(e) => {
                        e.stopPropagation()
                        this.props.removeCodeTab(tab.file, index, this.props.contentUUID)
                      }}
                      name="close"
                      ratio={0.9}
                      style={{ cursor: 'pointer' }}
                    />
                  )
                    : (
                      <div
                        uk-spinner="ratio: 0.35"
                        className="uk-position-center-right"
                      />
                    )}
                </a>
              </li>
            )
          })}
        </ul>
        <div
          className="uk-flex uk-flex-row"
        >
          {
            ((this.props.isFullScreen && this.props.tabs.length > 0) || !this.props.isFullScreen) && (
              <div
                className="uk-flex-1"
                style={{
                  minWidth: '50%',
                }}
              >
                {this.renderEditor()}
              </div>
            )
          }
          {
            this.props.extra && (
              <div
                className="uk-flex-1"
                style={{
                  minWidth: '50%',
                  backgroundColor: '#000',
                }}
              >
                {this.props.extra}
              </div>
            )
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ codeReview }) => ({
  tabs: codeReview.tabs,
  engine: codeReview.engine,
  code: codeReview.code,
  indexEditing: codeReview.indexEditing,
  highlightedFiles: codeReview.highlightedFiles,
  loadingVersion: codeReview.loadingVersion,
})

export default connect(mapStateToProps, {
  changeCodeTab,
  removeCodeTab,
  changeCode,
})(CodeReview)
